module.exports = __webpack_public_path__ + "img/0Q3B2213_Wood_MockedUp.bfa492c0.jpg";